
<template>
    <div class="layout-rctable-container user-authent">
        <Helpinfo :helpData="helpData">
            <div slot="slotR">
                <Button v-if="!parentSid && !['authing'].includes(this.authentStatus)"
                        type="primary"
                        style="margin-right: 85px"
                        @click="upgrade">{{$t('升级企业认证')}}</Button>
                <div class="back-div"
                     @click="$router.go(-1)">
                    <Icon type="ios-arrow-dropleft"
                          size="16" />
                    <span>{{$t('返回')}}</span>
                </div>
            </div>
        </Helpinfo>
        <div class="auth-container">
            <h3>{{$t('认证信息')}}</h3>
            <Form ref="form"
                  :model="formData"
                  :rules="rules"
                  :label-colon="true"
                  :label-width="100"
                  class="authent-form"
                  @submit.native.prevent>
                <FormItem :label="$t('姓名')"
                          prop="realName"
                          class="form-item">
                    <Input v-if="!readonly"
                           v-model="formData.realName" />
                    <incognito v-else
                               type='name'
                               :sensitiveData='formData.realName' />
                </FormItem>
                <FormItem :label="$t('身份证号码')"
                          prop="authId"
                          class="form-item">
                    <Input v-if="!readonly"
                           v-model="formData.authId" />
                    <span v-else>
                        <incognito v-if="formData.authId"
                                   :sensitiveData=formData.authId />
                    </span>
                </FormItem>
                <FormItem :label="$t('认证状态')"
                          class="form-item">
                    <span v-html="authentStatusTxt"></span>
                    <Poptip placement="right"
                            v-if="authentStatus === 'authing'"
                            trigger="hover"
                            style="width: auto;">
                        <i style="margin-left:5px; color: #ffc000"
                           class="icon-prompt-1-o" />
                        <span slot="content">{{$t('审核将会在1-2天内完成，请耐心等待')}}</span>
                    </Poptip>
                </FormItem>
                <FormItem :label="$t('认证反馈信息')"
                          v-if="!['noAuth', 'authing'].includes(this.authentStatus)"
                          prop="remark"
                          class="form-item">
                    <p style="width:700px">{{formData.remark || '--'}}</p>
                </FormItem>
                <FormItem :label="$t('图像采集信息')"
                          prop="idCardReverse"
                          class="form-item"
                          style="width: 900px;">
                    <div class="card-img-cont">
                        <div class="card-wrap">
                            <Upload v-if="canAction"
                                    action="/"
                                    :show-upload-list="false"
                                    :before-upload="handlePostive"
                                    :format="fileTypes"
                                    accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
                                    :max-size="fileSize">
                                <p class="img-wrap front"
                                   style="corsor: pointer">
                                    <img v-if="idCardFrontSrc"
                                         :src="idCardFrontSrc"
                                         alt="">
                                    <span v-else
                                          class="icon-wrap">
                                        <i class="icon-snapshot-o"
                                           style="font-size: 24px; color: #fff"></i>
                                    </span>
                                </p>
                            </Upload>
                            <p v-else
                               class="img-wrap">
                                <img v-if="idCardFrontSrc"
                                     :src="idCardFrontSrc"
                                     alt="">
                            </p>
                            <p>{{$t('身份证(人像面)')}}
                                <!-- <a href="javascript:;"
                                   v-if="formData.idCardFront && canDownload"
                                   @click="download('idCardFront')">{{$t('下载')}}</a> -->
                            </p>
                            <p class="err-msg"
                               v-if="showIdCardFrontMsg">{{idCardFrontMsg}}</p>
                        </div>
                        <div class="card-wrap">
                            <Upload v-if="canAction"
                                    action="/"
                                    :show-upload-list="false"
                                    :before-upload="handleBack"
                                    :format="fileTypes"
                                    accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
                                    :max-size="fileSize">
                                <p class="img-wrap reserve"
                                   style="corsor: pointer">
                                    <img v-if="idCardReverseSrc"
                                         :src="idCardReverseSrc"
                                         alt="">
                                    <span v-else
                                          class="icon-wrap">
                                        <i class="icon-snapshot-o"
                                           style="font-size: 24px; color: #fff"></i>
                                    </span>
                                </p>
                            </Upload>
                            <p v-else
                               class="img-wrap">
                                <img v-if="idCardReverseSrc"
                                     :src="idCardReverseSrc"
                                     alt="">
                            </p>
                            <p>{{$t('身份证(国徽面)')}}
                                <!-- <a href="javascript:;"
                                   v-if="formData.idCardReverse && canDownload"
                                   @click="download('idCardReverse')">{{$t('下载')}}</a> -->
                            </p>
                            <p class="err-msg"
                               v-if="showIdCardReverseMsg">{{idCardReverseMsg}}</p>
                        </div>
                    </div>
                    <div style="margin-top: 10px;line-height: 20px;color:#808080;">
                        <p>{{$t('图片格式为jpg,jpeg,png')}}</p>
                        <p>{{$t('图片最大为5M')}}</p>
                    </div>
                </FormItem>
                <!-- <FormItem v-if="canAction"
                          prop="realNameCheck"
                          style="margin: -10px 0 30px 0px;">
                    <CheckboxGroup v-model="formData.realNameCheck"
                                   style="height: 24px;">
                        <Checkbox label="1">
                            <span style="color: #EA5200">{{$t('我已阅读并同意')}}
                                <router-link target="_blank"
                                             to="/privacyStatement">{{$t('《隐私声明》')}}</router-link>
                            </span>
                        </Checkbox>
                    </CheckboxGroup>
                </FormItem> -->
                <FormItem v-if="canAction">
                    <Button @click="cancel">{{$t('重置')}}</Button>
                    <Button type="primary"
                            :loading="loading"
                            style="margin-left: 10px"
                            @click="handleSubmit">{{loading ? $t('提交中') : $t('提交')}}</Button>
                </FormItem>
            </Form>
        </div>
    </div>
</template>
<script>
import Helpinfo from '@/views/components/basic/helpinfo'
import { isCardNumber15and18 } from '@/service/validator.js'
import { fileReader } from '@/service/utils.js'
import { authentMaps } from '@/service/const.js'
import API from '@/service/api'
export default {
    name: 'authent',
    components: {
        Helpinfo
    },
    data () {
        const validRealName = (rule, value, callback) => {
            const reg = /[^\u4E00-\u9FA5]/g
            if (reg.test(value)) {
                callback(new Error(this.$t('只能输入中文')))
            }
            if (value.length > 10) {
                callback(new Error(this.$t('名称最长不超过10个汉字')))
            }
            callback()
        }
        return {
            helpData: {
                type: 'SYSSET',
                modelName: this.$t('用户认证')
            },
            loading: false,
            formData: {
                realName: '',
                authId: '',
                idCardFront: '',
                idCardReverse: '',
                remark: '',
                realNameCheck: []
            },
            idCardFrontSrc: '',
            idCardReverseSrc: '',
            rules: {
                realName: [
                    { required: true, message: '该字段不能为空', trigger: 'blur' },
                    { validator: validRealName, trigger: 'blur' }
                ],
                authId: [
                    { required: true, message: '该字段不能为空', trigger: 'blur' },
                    { validator: isCardNumber15and18, trigger: 'blur' }
                ],
                idCardFront: [
                    { required: true, message: '必须上传身份证照片', trigger: 'blur' }
                ],
                idCardReverse: [
                    { required: true, message: '必须上传身份证照片', trigger: 'blur' }
                ]
                // realNameCheck: [
                //     {
                //         required: true,
                //         type: 'array',
                //         min: 1,
                //         message: this.$i18n.t('请勾选已阅读《隐私声明》'),
                //         trigger: 'change'
                //     }
                // ]
            },
            fileTypes: Object.freeze(['jpg', 'jpeg', 'png', 'PNG', 'JPG', 'JPEG']),
            fileSize: 1024 * 5,
            showIdCardFrontMsg: false,
            idCardFrontMsg: '',
            showIdCardReverseMsg: false,
            idCardReverseMsg: '',
            userSid: this.$store.state.user.currentUser.info.userSid || '',
            authentStatus: this.$store.state.user.currentUser.info.authentStatus || 'noAuth'
        }
    },
    computed: {
        // 待认证,认证失败可以编辑，其他的都是只读状态
        readonly () {
            return !['noAuth', 'authFiled'].includes(this.authentStatus)
        },
        // 提交操作：待认证和认证失败才可以提交操作
        canAction () {
            return ['noAuth', 'authFiled'].includes(this.authentStatus)
        },
        canDownload () {
            return ['authing', 'authSucceed'].includes(this.authentStatus)
        },
        authentStatusTxt () {
            const text = authentMaps[this.authentStatus]
            return `<span style="color: ${this.getColor(this.authentStatus)}">${this.$t(text)}</span>`
        },
        parentSid () {
            return this.$store.state.user.currentUser.info.parentSid || null
        }
    },

    async created () {
        if (this.authentStatus !== 'noAuth') {
            const data = await this.getAuthInfo()
            this.initData(data)
        }
    },
    beforeDestroy () {
        window.URL.revokeObjectURL(this.idCardFrontSrc)
        window.URL.revokeObjectURL(this.idCardReverseSrc)
    },
    methods: {
        upgrade () {
            this.$router.push({ path: '/mgt/authent/company' })
        },
        cancel () {
            this.$refs.form.resetFields()
            this.formData = {
                realName: '',
                authId: '',
                idCardFront: '',
                idCardReverse: '',
                remark: '',
                realNameCheck: []
            }
            this.idCardFrontSrc = ''
            this.idCardReverseSrc = ''
        },
        getAuthInfo () {
            return this.axios.get(this.urlFormat(`${API.USER_AUTH_INFO}/${this.userSid}`, true))
        },
        initData (data) {
            this.formData = {
                realName: data.realName,
                authId: data.authId,
                idCardFront: data.idCardFront,
                idCardReverse: data.idCardReverse,
                remark: data.remark
            }
            this.getIdCardSrc('idCardFront')
            this.getIdCardSrc('idCardReverse')
        },
        getIdCardSrc (idCard) {
            this.axios.get(this.urlFormat(API.IDCARD_IMAGE, true), {
                params: {
                    fileId: encodeURIComponent(this.formData[idCard])
                },
                headers: {
                    notDownload: true
                },
                responseType: 'blob'
            }).then(data => {
                const src = window.URL.createObjectURL(new Blob([data]))
                this[`${idCard}Src`] = src
            })
        },
        // 身份证正面
        handlePostive (file) {
            const arr = file.name ? file.name.split('.') : []
            if (!this.fileTypes.includes(arr[arr.length - 1])) {
                this.idCardFrontMsg = '图片格式必须为png，jpeg，jpg，PNG，JPG，JPEG'
                this.showIdCardFrontMsg = true
                return
            }
            if ((file.size / 1024) > this.fileSize) {
                this.idCardFrontMsg = '图片大小不能超过5M'
                this.showIdCardFrontMsg = true
                return
            }
            this.showIdCardFrontMsg = false
            this.idCardFrontMsg = ''
            this.handleUpload(file, 'idCardFront')
            return false
        },
        // 身份证背面
        handleBack (file) {
            const arr = file.name ? file.name.split('.') : []
            if (!this.fileTypes.includes(arr[arr.length - 1])) {
                this.idCardReverseMsg = '图片格式必须为png，jpeg，jpg，PNG，JPG，JPEG'
                this.showIdCardReverseMsg = true
                return
            }
            if ((file.size / 1024) > this.fileSize) {
                this.idCardReverseMsg = '图片大小不能超过5M'
                this.showIdCardReverseMsg = true
                return
            }
            this.showIdCardReverseMsg = false
            this.idCardReverseMsg = ''
            this.handleUpload(file, 'idCardReverse')
            return false
        },
        async handleUpload (file, key) {
            const base64 = await fileReader(file)
            const data = {
                base64Data: base64
            }
            this.axios.post(this.urlFormat(`${API.UPLOAD_IMG}/auth`, true), data).then(res => {
                if (res !== 'FAILURE') {
                    this.formData[key] = res
                    this.getIdCardSrc(key)
                }
            })
        },
        handleSubmit () {
            this.$refs.form.validate(valid => {
                if (!valid) return
                const data = {
                    userSid: this.userSid,
                    ...this.formData
                }
                data.realNameCheck = true // this.formData.realNameCheck.includes('1')
                this.loading = true
                this.axios.post(this.urlFormat(API.USER_AUTH, true), data).then(async res => {
                    this.loading = false
                    if (res && res.status) {
                        const result = await this.getAuthInfo()
                        const authData = {
                            authentStatus: result.certificationStatus,
                            authentRemark: result.remark
                        }
                        this.$store.commit('setUserAuthData', authData)
                        this.$router.go(-1)
                    }
                }).catch(e => {
                    this.loading = false
                })
            })
        },
        // download (sign) {
        //     window.open(this.$store.state.app.url.RestUrl + this.formData[sign])
        // }
        download (idCardType) {
            this.axios.get(this.urlFormat(API.IDCARD_DOWNLOAD, true), {
                params: {
                    userId: encodeURIComponent(this.$encrypt(String(this.userSid))),
                    idCardType
                },
                responseType: 'arraybuffer',
                Headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                if (res) {
                    this.$Message.success(this.$t('下载成功'))
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.user-authent {
    .auth-container {
        display: flex;
        padding: 10px;
        h3 {
            width: 200px;
            line-height: 32px;
            text-align: center;
        }
        .authent-form {
            .form-item {
                width: 400px;
            }
        }
        .card-img-cont {
            display: flex;
            justify-content: space-between;
            padding: 15px;
            padding-bottom: 5px;
            border: 1px solid #e9e9e9;
            .card-wrap {
                width: 350px;
                text-align: center;
                .ivu-upload {
                    width: 100%;
                }
                .img-wrap {
                    position: relative;
                    width: 350px;
                    height: 200px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    &.front {
                        background-image: url('../../../assets/images/authent/card-front.png');
                        background-size: 100% 100%;
                    }
                    &.reserve {
                        background-image: url('../../../assets/images/authent/card-reserve.png');
                        background-size: 100% 100%;
                    }
                    .icon-wrap {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        padding-top: 12px;
                        width: 50px;
                        height: 50px;
                        text-align: center;
                        transform: translate(-50%, -50%);
                        z-index: 10;
                        background: #1f68b3;
                        border-radius: 50%;
                    }
                }
            }
        }
        .err-msg {
            line-height: 20px;
            color: red;
        }
    }
}
</style>
